import { render, staticRenderFns } from "./PlayerWrapper.vue?vue&type=template&id=b3fce672&scoped=true&"
import script from "./PlayerWrapper.vue?vue&type=script&lang=js&"
export * from "./PlayerWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PlayerWrapper.vue?vue&type=style&index=0&id=b3fce672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fce672",
  null
  
)

export default component.exports